import React from "react";
import { Box } from "@mui/material";
import LogoutIcon from "@icons/myicons/sidebar/logout.svg?react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { useMandatorContext } from "@bn/theming";
import { useAppLayout } from "@providers/AppLayoutProvider";
import { MenuGroup } from "@components/common/layouts/AppSidebar/SidebarMenu/MenuGroup.tsx";
import { MenuItem } from "@components";
import { useArivaHeaderFailed } from "@components/ArivaHeader";
import { USE_INTERNAL_AUTH } from "@helpers";
import { MandatorsSlugSelect } from "./MandatorsSlugSelect";

export const UserMenu = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { sidebarCollapsed: collapsed } = useAppLayout();
  const { isAriva } = useMandatorContext();
  const arivaHeaderFailed = useArivaHeaderFailed();
  // On desktop ariva users log out through the ARIVA header (useArivaLogout).
  const showLogout = !isAriva || USE_INTERNAL_AUTH || arivaHeaderFailed;

  return (
    <Box display="flex" alignItems="center" gap={2}>
      <Box flex={1} minWidth={0}>
        {showLogout && (
          <MenuGroup>
            <MenuItem
              to="/logout"
              name={t("appSidebar.menu.logout")}
              before={<LogoutIcon />}
              selected={pathname === "/logout"}
            />
          </MenuGroup>
        )}
      </Box>
      {/* Dev-only mandator switcher; self-hides outside dev/staging. */}
      {!collapsed && <MandatorsSlugSelect />}
    </Box>
  );
};
